$(function () {
    var $addEditPlacementModal = $('#add-edit-placement-option-modal');
    $('.createPlacement-btn').on('click', function () {
        $addEditPlacementModal.modal('show');
        $addEditPlacementModal.find('input[type=hidden][name="id"], input[type=text], select, textarea').val('').trigger('change');
        $addEditPlacementModal.find('textarea[name="description"]').summernote('code', '');

        var visible = 1;
        $('input[type="checkbox"][name="visible"]').val(visible).prop('checked', true);

        $addEditPlacementModal.find('.allocations-warning-container, .allocations-checkbox').empty();
    });

    $('.managePlacement-btn').on('click', function () {
        var $modal         = $addEditPlacementModal;
        var $form          = $modal.find('form');
        var $row           = $(this).closest('.placement-row');
        var placement      = $row.data('placement');
        var academicYear   = $row.data('academic-year');
        var buildStartTime = Math.floor(placement.start_time / (60 * 60)) + ':' + (Math.floor(placement.start_time / 60) % 60 < 10 ? '0' : '') + Math.floor(placement.start_time / 60) % 60;
        var buildEndTime   = Math.floor(placement.end_time / (60 * 60)) + ':' + (Math.floor(placement.end_time / 60) % 60 < 10 ? '0' : '') + Math.floor(placement.end_time / 60) % 60;
        var visible        = parseInt(placement.visible, 10);

        $modal.find('.allocations-warning-container, .allocations-checkbox').empty();

        var totalAllocationsCount = placement.allocations && placement.allocations.length || 0;

        // Check if there are any timetable events for the placement
        if (totalAllocationsCount > 0) {
            var today          = new Date();
            var placementTitle = placement.placement_type_description + ' - ' + placement.name;

            var futureAllocationsCount = 0;
            var futureEventIds         = [];

            // Find timetable events occurring in the future
            for (const allocation of placement.allocations) {
                var allocationDate = new Date(allocation.start.split('/').reverse().join('-'));
                if (allocationDate >= today) {
                    futureAllocationsCount++;
                    futureEventIds.push(allocation.event_id);
                }
            }

            var firstAllocationStartDate = placement.allocations[0].start;
            var lastAllocationStartDate  = placement.allocations.at(-1).start;

            // Check if the dates are the same and if so, only show start date
            var allocationDates = firstAllocationStartDate === lastAllocationStartDate
                ? firstAllocationStartDate
                : firstAllocationStartDate + ' - ' + lastAllocationStartDate;

            var allocationWarningText = '<h4><i class="' + FontAwesome.prefix('solid', 'triangle-exclamation') + '"></i> Timetabled Events for ' + academicYear + '</h4>' +
                '<strong>Placement:</strong> ' + placementTitle + '<br>' +
                '<strong>Time:</strong> ' + buildStartTime + ' - ' + buildEndTime + '<br>' +
                '<strong>Dates:</strong> ' + allocationDates + '<br>' +
                '<strong>Total Events:</strong> ' + totalAllocationsCount + '<br>' +
                '<strong>Upcoming Events:</strong> ' + futureAllocationsCount;

            // If there are future timetable events, add a warning message and checkbox to update them
            if (futureAllocationsCount > 0) {
                allocationWarningText +=
                    '<br><strong>Action:</strong> To update upcoming timetable events for this placement, click the checkbox below.';
            }

            var allocationWarningDiv = $('<div role="alert"></div>').addClass('alert alert-danger').html(allocationWarningText);
            $modal.find('.allocations-warning-container').append(allocationWarningDiv);

            if (futureAllocationsCount > 0) {
                var updateEventsCheckbox = '<label for="update_timetable_events" class="checkbox-inline"><input type="checkbox" id="update_timetable_events" name="update_timetable_events"><strong>Update all ' + futureAllocationsCount + ' upcoming timetable events</strong></label>';

                var updateEventsDiv = $('<div class="form-group"></div>').html(updateEventsCheckbox);
                $modal.find('.allocations-checkbox').append(updateEventsDiv);
            }

            // If checked, populate hidden input with event IDs
            $modal.find('#update_timetable_events').on('change', function () {
                $form.find('input[name="event_ids"]').val(this.checked ? JSON.stringify(futureEventIds) : '');
            });
        }

        $modal.modal('show');
        $modal.find('span.placementName').text(placement.name);
        $form.find('input[name="id"]').val(placement.placement_id);
        $form.find('input[name="shortcode"]').val(placement.shortcode);
        $form.find('select[name="location_id"]').val(placement.location_id).trigger('change');
        $form.find('select[name="placement_type_id"]').val(placement.placement_type_id).trigger('change');
        $form.find('input[name="name"]').val(placement.name);
        $form.find('input[name="start_time"]').val(buildStartTime).trigger('change');
        $form.find('input[name="end_time"]').val(buildEndTime).trigger('change');
        $form.find('textarea[name="description"]').summernote().summernote('code', placement.description);
        $form.find('input[type="checkbox"][name="visible"][value="' + visible + '"]').prop('checked', true);
    });

    $('#placement-start-time, #placement-end-time').datetimepicker({
        minTime: '08:00',
        maxTime: '22:15',
        datepicker: false,
        format: 'H:i',
        step: 15,
    });

    $addEditPlacementModal.on('submit', function (e) {
        const $eventsCheckbox = $('#update_timetable_events');
        const $button         = $('#save-placement-option');

        if ($button.prop('disabled')) {
            return false;
        }

        $button.prop('disabled', true);
        $button.find('i').removeClass().addClass(FontAwesome.prefix('solid', 'spinner', true));
        $button.find('span').text('Saving...');

        if ($eventsCheckbox.length && $eventsCheckbox.is(':visible') && !$eventsCheckbox.is(':checked')) {
            if (!confirm('Are you sure you want to save without updating the timetable events?')) {
                e.preventDefault();
            }
        }
    });
});
